document.addEventListener("DOMContentLoaded", function () {
  // Helper function to open an accordion if it's closed
  function openAccordion(targetId) {
    var header = document.querySelector(`#${targetId} .yv-accordion-header`);
    var content = document.querySelector(`#${targetId} .yv-accordion-content`);
    if (header && content && content.style.display !== "block") {
      header.classList.add("active");
      content.style.display = "block";
    }
  }

  // Scroll + open for the first area
  var purchaseAreaLink = document.querySelector('a[href="#includeArea"]');
  if (purchaseAreaLink) {
    purchaseAreaLink.addEventListener("click", function (event) {
      event.preventDefault();
      var purchaseArea = document.querySelector("#targetArea");
      if (purchaseArea) {
        purchaseArea.scrollIntoView({ behavior: "smooth" });
        // open target accordion after scroll
        openAccordion("targetArea");
      }
    });
  }

  // Scroll for the second area
  var shippingAreaLink = document.querySelector('a[href="#shippingArea"]');
  if (shippingAreaLink) {
    shippingAreaLink.addEventListener("click", function (event) {
      event.preventDefault();
      var shippingArea = document.querySelector("#shippingTargetArea");
      if (shippingArea) {
        shippingArea.scrollIntoView({ behavior: "smooth" });
        // open target accordion after scroll
        openAccordion("shippingTargetArea");
      }
    });
  }
  // Scroll for the featured-product area
  var productAreaLink = document.querySelector('a[href="#purchaseArea"]');
  if (productAreaLink) {
    productAreaLink.addEventListener("click", function (event) {
      event.preventDefault();
      var productArea = document.querySelector("#purchaseArea");
      if (productArea) {
        productArea.scrollIntoView({ behavior: "smooth" });
      }
    });
  }
});
